export const AUTH0_CALLBACK_URLS_WHITELIST_ENABLED = false;
export const EMAIL_VERIFICATION_FLOW_ENABLED = true;
export const OMIT_SKIP_VERIFICATION_UPON_RETURN_TO_CLIENT = false;
export const COOKIES_BASED_SKIP_VERIFICATION = true;
